import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CompanyService } from 'src/app/services/company.service';
import { GetUserCompany } from 'src/app/models/company/get-company';

@Component({
  selector: 'app-companies-admin',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './companies-admin.component.html',
  styles: ``
})
export class CompaniesAdminComponent implements OnInit {
  showFilters: boolean = false;

  constructor(private CompaniesService: CompanyService) { // Inject the CompaniesService here    
  }

  companiesList: GetUserCompany[] = [];
  companiesListFiltered: GetUserCompany[] = [];

  ngOnInit(): void {
    this.getCompanies();
  }

  showFilter(): void {
    this.showFilters = !this.showFilters;
  }

  getCompanies(){
    this.CompaniesService.getCompany().subscribe({
      next: (res: any) => {
        this.companiesList = res;
        this.companiesListFiltered = res;
      }
    });
  };
}
